import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Tender } from '../../../../models';
import { CoverLetter } from '../../../../../common/models';
import { TenderService } from '../../../../services';
import { CoverLetterService } from '../../../../../common/services';
import { ToastService } from '../../../../../main/services';

@Component({
    selector: 'jft-tender-edit-modal',
    templateUrl: './tender-edit-modal.component.html',
    styleUrls: ['./tender-edit-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TenderEditModalComponent implements OnInit {

    public tender: Tender;
    public coverLetter: CoverLetter;
    public form: UntypedFormGroup;
    public loading: boolean = false;

    constructor(
        private activeModal: NgbActiveModal,
        private tenderService: TenderService,
        private coverLetterService: CoverLetterService,
        private toast: ToastService
    ) {
    }

    public ngOnInit() {
        this.initializeForm();
    }

    private initializeForm() {
        this.form = new UntypedFormGroup({
            name: new UntypedFormControl(this.tender.name, [Validators.required]),
            cover_letter_text: new UntypedFormControl(this.coverLetter.text || '', [])
        });
    }

    public close() {
        this.activeModal.dismiss();
    }

    public save() {
        if (this.form.invalid) {
            return;
        }

        this.loading = true;
        this.form.disable();

        const tenderData = {
            name: this.form.value.name
        };

        const coverLetterData = {
            text: this.form.value.cover_letter_text
        };

        // Update tender name
        this.tenderService.updateDetails(this.tender, tenderData).subscribe(
            (updatedTender: Tender) => {
                // Update cover letter text
                const updatedCoverLetter = CoverLetter.create(this.coverLetter.toJSON());
                updatedCoverLetter.text = coverLetterData.text;
                this.coverLetterService.update(this.tender, updatedCoverLetter).subscribe(
                    (coverLetterResult: CoverLetter) => {
                        this.loading = false;
                        this.form.enable();
                        this.toast.success('Tender information updated successfully');
                        this.activeModal.close({
                            tender: updatedTender,
                            coverLetter: coverLetterResult
                        });
                    },
                    (error) => {
                        this.loading = false;
                        this.form.enable();
                        this.toast.error('Failed to update cover letter: ' + error);
                    }
                );
            },
            (error) => {
                this.loading = false;
                this.form.enable();
                this.toast.error('Failed to update tender: ' + error);
            }
        );
    }

    public getFirstFormGroupErrorLabel(form: UntypedFormGroup): string {
        for (const controlName in form.controls) {
            const control = form.controls[controlName];
            if (control.invalid && control.errors) {
                const fieldName = controlName.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                const firstError = Object.keys(control.errors)[0];
                return `${fieldName} is ${firstError}`;
            }
        }
        return '';
    }
}
